import {Component, EventEmitter, Output} from '@angular/core';
declare const $;
import { AccessRights, UsersService, InterfacePermissions } from "../../../services/users.service";

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.css'],
    standalone: false
})
export class SideNavComponent {
  public InterfacePermissions = InterfacePermissions;
  public AccessRights = AccessRights;

  @Output() onComponentSelected: EventEmitter<any> = new EventEmitter();

  constructor(public usersService: UsersService) {

  }

  public selectedTab: string = "admin_objects";

  public select(name: string) {
    this.onComponentSelected.emit(name);
    this.selectedTab = name;
  }

  public isSelected(name: string): boolean {
    return this.selectedTab == name;
  }
  public toggleMenu()
  {
    var trigger = $('.js-sidemenu-trigger');
    trigger.toggleClass('is-active');
    var parent = trigger.parents('.js-page');
    parent.toggleClass('menu-opened');
  }
}
